'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _bTextinputMThemeWebsearchMHasClearYes = (require('./../../textinput/textinput.react.js'), require('./../../../desktop.blocks/textinput/textinput.react.js'), require('./../../textinput/_theme/textinput_theme_websearch.react.js'), (require('./../../textinput/_has-clear/textinput_has-clear_yes.react.js').default || require('./../../textinput/_has-clear/textinput_has-clear_yes.react.js')).applyDecls());

var _bTextinputMThemeWebsearchMHasClearYes2 = _interopRequireDefault(_bTextinputMThemeWebsearchMHasClearYes);

(require('./../../textinput/__clear/textinput__clear.react.js').default || require('./../../textinput/__clear/textinput__clear.react.js')).applyDecls();

(require('./../../textinput/__icon/textinput__icon.react.js').default || require('./../../textinput/__icon/textinput__icon.react.js')).applyDecls();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'search2',
    elem: 'input',
    content: function content(props) {
        return props.input || _react2.default.createElement(_bTextinputMThemeWebsearchMHasClearYes2.default, props);
    }
}, {
    isInput: function isInput(child) {
        return child && typeof child.type === 'function' && child.type.displayName === 'search2__input';
    }
});